import React from 'react'
import { IconProps } from '../../types/types'

const IconGlobe:React.FC<IconProps> = ({ size = 18, color = '#0050FF' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.00005 16.0704C12.9765 16.0704 16.2001 12.8468 16.2001 8.87043C16.2001 4.89396 12.9765 1.67041 9.00005 1.67041C5.0236 1.67041 1.80005 4.89396 1.80005 8.87043C1.80005 12.8468 5.0236 16.0704 9.00005 16.0704Z" stroke={color} strokeWidth="1.296" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1.80005 8.87036H16.2001" stroke={color} strokeWidth="1.296" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.00022 16.0704C10.392 16.0704 11.5202 12.8468 11.5202 8.87043C11.5202 4.89396 10.392 1.67041 9.00022 1.67041C7.60846 1.67041 6.48022 4.89396 6.48022 8.87043C6.48022 12.8468 7.60846 16.0704 9.00022 16.0704Z" stroke={color} strokeWidth="1.296" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default IconGlobe